import React from 'react'

function Label({text, type}) {
    return (
        <p className={`label ${type}`}>{text}</p>
    )
}

export default Label
